import BaseService from "./BaseService";

export default class PerfilAlunoService extends BaseService {

    constructor(self) {
        super(self);
    }

    RetornaDadosAluno(parameters) {
        if (parameters && parameters.token) {
            return this.ExecutaFetch("/api/PerfilAluno/RetornaDadosAluno?token=" + parameters.token, "GET");
        }
        else if (sessionStorage.AlunoToken) {
            return this.ExecutaFetch("/api/PerfilAluno/RetornaDadosAluno?token=" + sessionStorage.AlunoToken, "GET");
        }
        else {
            return null;
        }
    }

    AtualizaAlunoCadastro(parameters) {
        return this.ExecutaFetch("/api/PerfilAluno/AtualizaAlunoCadastro", "POST", parameters);
    }

    RangePeriodosAlunos(parameters) {
        return this.ExecutaFetch("/api/PerfilAluno/RangePeriodosAlunos", "POST", parameters);
    }
}